export const DOMAIN = import.meta.env.VITE_DOMAIN;
export const IMAGES = DOMAIN + 'img/';
export const IMAGES_USERS = IMAGES + 'users/';
export const IMAGES_CONTACTS = IMAGES + 'contacts/';